<template>
  <div>
    <v-btn color="primary" @click="dialog = true"
      ><v-icon class="mr-2">mdi-cash</v-icon> Payslip</v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="1300px">
      <v-card>
        <v-card-title
          >PAYSLIP <v-spacer></v-spacer> <wages-modal
        /></v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-select
                outlined
                dense
                label="Branch"
                :items="branchOptions"
                item-text="branch_name"
                item-value="id"
                v-model="selectedBranchId"
                prepend-inner-icon="mdi-source-branch"
                clearable
                @change="onBranchChange"
              ></v-select>
              <v-select
                outlined
                dense
                class="mt-n4"
                label="Employee"
                :items="filteredEmployees"
                item-text="name"
                v-model="selectedEmployee"
                :rules="rules"
                prepend-inner-icon="mdi-account-circle"
                @change="selectEmployee(selectedEmployee)"
                return-object
              ></v-select>
              <!-- <v-text-field
                label="Employee Position"
                prepend-inner-icon="mdi-briefcase"
                class="mt-n4"
                readonly
                outlined
                dense
                v-model="selectedEmployee.position.name"
              ></v-text-field> -->
              <v-text-field
                v-if="!isFixedMode"
                class="mt-n4"
                outlined
                dense
                prepend-inner-icon="mdi-timer-sand"
                label="Total Days Worked"
                v-model="form.total_days_worked"
                type="number"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                v-else
                class="mt-n4"
                outlined
                dense
                prepend-inner-icon="mdi-cash-multiple"
                label="Monthly Salary (Fixed)"
                :value="convertFormat(selectedEmployee.monthly_salary || 0)"
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                outlined
                dense
                prepend-inner-icon="mdi-calendar-month"
                label="Month"
                :items="months"
                item-text="text"
                item-value="value"
                v-model="form.month"
                :rules="rules"
              ></v-select>
              <v-text-field
                class="mt-n4"
                outlined
                dense
                prepend-inner-icon="mdi-timer-sand"
                label="Overtime/Hrs."
                v-model="form.overtime"
                type="number"
                :rules="rules"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                prepend-inner-icon="mdi-calendar-month"
                label="Year"
                v-model="form.year"
                type="number"
                :rules="rules"
              ></v-text-field>
              <v-select
                class="mt-n4"
                outlined
                dense
                prepend-inner-icon="mdi-calendar-check"
                label="Half"
                :items="['1st Half', '2nd Half']"
                v-model="form.half"
                :rules="rules"
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-if="showPosition" class="mt-n8">
            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <h3 class="text-h6">
                  Employee Position:
                  <span class="font-weight-regular">{{
                    selectedEmployee.position.name
                  }}</span>
                </h3>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card outlined class="pa-3">
                <h3 class="text-h6" v-if="isFixedMode">
                  Monthly Salary:
                  <span class="font-weight-regular"
                    >{{ selectedEmployee.monthly_salary }} Php</span
                  >
                </h3>
                <h3 class="text-h6" v-else>
                  Daily Rate:
                  <span class="font-weight-regular"
                    >{{ selectedEmployee.position.base_rate_per_day }} Php</span
                  >
                </h3>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined class="pa-3">
                <h3 class="text-h6">
                  Overtime Rate:
                  <span class="font-weight-regular"
                    >{{ selectedEmployee.overtime_rate }} Php</span
                  >
                </h3>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card color="blue" dark>
                <v-card-title
                  >Employee Benefits - {{ totalBenefitAmount }}</v-card-title
                >
                <v-card-text>
                  <v-data-table
                    :items="employeeBenefits"
                    :headers="employeeBenefitsHeaders"
                  >
                    <!-- select button here -->
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        color="success"
                        @click="addToDeductions(item)"
                        >Select</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card color="yellow">
                <v-card-title>Cash Advances - {{ totalCAAmount }}</v-card-title>
                <v-card-text>
                  <v-data-table
                    :items="cashAdvances"
                    :headers="cashAdvancesHeaders"
                  >
                    <!-- select button here -->
                    <template v-slot:item.action="{ item }">
                      <v-btn small color="success" @click="openCAEdit(item)"
                        >Select</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- PENALTIES (fixed salary only) -->
          <v-row v-if="isFixedMode">
            <v-col>
              <v-card color="red lighten-4">
                <v-card-title
                  >Penalties - {{ convertFormat(totalPenalties) }}</v-card-title
                >
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Absences (Php)"
                        v-model="penalties.absences"
                        type="number"
                        min="0"
                        prepend-inner-icon="mdi-account-cancel"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Lates (Php)"
                        v-model="penalties.lates"
                        type="number"
                        min="0"
                        prepend-inner-icon="mdi-clock-alert"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Undertime (Php)"
                        v-model="penalties.undertime"
                        type="number"
                        min="0"
                        prepend-inner-icon="mdi-timer-off"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- INCOME -->
          <v-row>
            <v-col>
              <v-simple-table>
                <thead>
                  <tr>
                    <th colspan="4" class="green lighten-5">
                      <h2 class="green--text">INCOME</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="isFixedMode">
                    <!-- fixed salary income -->
                    <td>1</td>
                    <td>Basic Salary (Fixed — {{ form.half }})</td>
                    <td>-</td>
                    <td>
                      <span class="green--text font-weight-bold">
                        {{ convertFormat(fixedBasePay) }}
                      </span>
                    </td>
                  </tr>
                  <tr v-else>
                    <!-- income -->
                    <td>1</td>
                    <td>Total Days Worked</td>
                    <td>{{ form.total_days_worked }}</td>
                    <td>
                      <span
                        v-if="selectedEmployee.position"
                        class="green--text font-weight-bold"
                      >
                        {{
                          convertFormat(
                            form.total_days_worked *
                              selectedEmployee.position.base_rate_per_day
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Overtime</td>
                    <td>{{ form.overtime }}</td>
                    <td>
                      <span
                        v-if="selectedEmployee.position"
                        class="green--text font-weight-bold"
                      >
                        {{
                          convertFormat(
                            form.overtime * selectedEmployee.overtime_rate
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <!-- total gross pay + overtime -->
                    <td>
                      <h3 v-if="selectedEmployee.position">
                        Total:
                        {{ "Php " + convertFormat(grossPay) }}
                      </h3>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-simple-table>
                <thead>
                  <tr>
                    <th colspan="4" class="red lighten-5">
                      <h2 class="red--text">DEDUCTIONS</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dec, index) in allDeductions" :key="index">
                    <!-- delete button -->
                    <td>
                      <v-btn
                        icon
                        color="red"
                        small
                        @click="removeDeduction(dec, index)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ dec.name }}</td>
                    <td class="red--text font-weight-bold">{{ dec.amount }}</td>
                  </tr>
                  <!-- total here -->
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <h3 class="">
                        Total:
                        {{ "Php " + convertFormat(totalDeductions) }}
                      </h3>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <!-- DEDUCTIONS -->
            <v-col cols="12" md="6">
              <v-card outlined class="pa-4">
                <h2 class="text-h5 mb-2 font-weight-bold">Summary</h2>
                <h3 class="text-h6">
                  Gross:
                  <span class="font-weight-regular">{{
                    convertFormat(grossPay)
                  }}</span>
                </h3>
                <h3 class="text-h6">
                  Deductions:
                  <span class="font-weight-regular">{{
                    convertFormat(totalDeductions)
                  }}</span>
                </h3>
                <h2 class="mt-4 text-h4">
                  Net Pay:
                  <span class="green--text font-weight-bold">{{
                    convertFormat(totalNet)
                  }}</span>
                </h2>
              </v-card>
              <v-textarea
                v-model="form.notes"
                label="Notes"
                prepend-inner-icon="mdi-note-plus"
                outlined
                class="mt-2"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <p class="caption">payslipModal.vue</p>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >
          <!-- <v-btn @click="printSlip" :loading="loading" color="success"
            ><v-icon class="mr-2">mdi-printer </v-icon> Print</v-btn
          > -->
          <v-btn @click="dialog = false" color="secondary"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- cash advance dialog -->
    <v-dialog v-model="showCADialog" persistent max-width="300px">
      <v-card>
        <v-card-text class="pa-5">
          <h3>Amount to pay</h3>
          <p>{{ selectedCA.reason }}</p>
          <v-text-field
            label="Amount"
            v-model="selectedCA.amount"
            prepend-inner-icon="mdi-cash"
            type="number"
          ></v-text-field>
          <v-btn color="primary" @click="amountToPay(selectedCA)" class="mr-2"
            >Submit</v-btn
          >
          <v-btn color="secondary" @click="showCADialog = false">Close</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import wagesModal from "./wagesModal.vue";
import axios from "axios";
export default {
  components: { wagesModal },
  data() {
    return {
      selectedCA: {},
      showCADialog: false,
      selectedDeductions: [],
      selectedDeductionHeaders: [
        {
          text: "Action",
          value: "action",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Amount",
          value: "amount",
        },
      ],
      selectedEmployee: {},
      selectedBranchId: null,
      employeeBenefits: [],
      employeeBenefitsHeaders: [
        { text: "Action", value: "action" },
        { text: "Name", value: "benefit.name" },
        { text: "Amount", value: "benefit.amount" },
        { text: "Account Number", value: "account_number" },
        { text: "Date Issued", value: "date_issued" },
      ],
      cashAdvances: [],
      cashAdvancesHeaders: [
        { text: "Action", value: "action" },
        { text: "Reason", value: "reason" },
        { text: "Amount", value: "amount" },
        { text: "Total Paid", value: "total_paid" },
        { text: "Balance", value: "balance" },
        { text: " Status", value: "status" },
        { text: "Date Issued", value: "date_issued" },
      ],
      showPosition: false,
      dialog: false,
      form: {
        employee_id: null,
        month: null,
        year: null,
        half: null,
        total_days_worked: null,
        deductions: [],
        gross: null,
        net: null,
        overtime: 0,
        notes: "n/a",
        pay_type: "daily",
      },
      penalties: {
        absences: null,
        lates: null,
        undertime: null,
      },
      rules: [(value) => !!value || "Field is Required."],
      loading: false,
      printableWage: {},
      months: [
        { text: "January", value: "1" },
        { text: "February", value: "2" },
        { text: "March", value: "3" },
        { text: "April", value: "4" },
        { text: "May", value: "5" },
        { text: "June", value: "6" },
        { text: "July", value: "7" },
        { text: "August", value: "8" },
        { text: "September", value: "9" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
    };
  },
  computed: {
    totalCAAmount() {
      return this.cashAdvances.reduce(
        (sum, ca) => sum + parseFloat(ca.balance),
        0
      );
    },
    totalBenefitAmount() {
      return this.employeeBenefits.reduce(
        (sum, benefit) => sum + parseFloat(benefit.benefit.amount),
        0
      );
    },
    ...mapGetters({
      employees: "employee/employees",
      wages: "wage/wages",
      default_server_url: "auth/default_server_url",
      user: "auth/user",
      branches: "branch/branches",
    }),

    branchOptions() {
      return this.branches || [];
    },
    filteredEmployees() {
      if (!this.selectedBranchId) return this.employees;
      return this.employees.filter(
        (e) => e.branch_id === this.selectedBranchId
      );
    },

    isFixedMode() {
      return (
        this.selectedEmployee &&
        this.selectedEmployee.employment_status === "regular"
      );
    },
    fixedBasePay() {
      // fixed salary is paid semi-monthly: half the monthly salary per payslip
      return (parseFloat(this.selectedEmployee.monthly_salary) || 0) / 2;
    },
    penaltyDeductions() {
      if (!this.isFixedMode) return [];
      let entries = [
        { key: "absences", name: "Absences" },
        { key: "lates", name: "Lates" },
        { key: "undertime", name: "Undertime" },
      ];
      return entries
        .filter((e) => parseFloat(this.penalties[e.key]) > 0)
        .map((e) => ({
          item_id: null,
          name: e.name,
          amount: parseFloat(this.penalties[e.key]),
          type: "penalty",
          penalty_key: e.key,
        }));
    },
    allDeductions() {
      return this.selectedDeductions.concat(this.penaltyDeductions);
    },
    totalPenalties() {
      return this.penaltyDeductions.reduce(
        (sum, dec) => sum + parseFloat(dec.amount),
        0
      );
    },
    grossPay() {
      if (this.isFixedMode) {
        return (
          this.fixedBasePay +
          this.form.overtime * this.selectedEmployee.overtime_rate
        );
      }
      if (this.selectedEmployee.position) {
        return (
          this.form.total_days_worked *
            this.selectedEmployee.position.base_rate_per_day +
          this.form.overtime * this.selectedEmployee.overtime_rate
        );
      }
      return 0;
    },
    totalDeductions() {
      return this.allDeductions.reduce(
        (sum, dec) => sum + parseFloat(dec.amount),
        0
      );
    },
    totalNet() {
      return this.grossPay - this.totalDeductions;
    },
  },

  methods: {
    ...mapActions({
      add_wage: "wage/add_wage",
    }),
    onBranchChange() {
      this.selectedEmployee = {};
      this.$store.dispatch("employee/get_employees", this.selectedBranchId);
    },
    printSlip() {
      if (!this.printableWage.id) {
        this.$alert({
          title: "Validation",
          message: "Please submit the payslip first.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      window.open(
        this.default_server_url +
          "/print_payslip/" +
          this.printableWage.id +
          "/" +
          (this.selectedEmployee.branch_id || this.user.branch.id),
        "_blank"
      );
    },
    amountToPay(ca) {
      console.log("amount to pay", ca);
      this.addToDeductions(ca);
      this.showCADialog = false;
    },
    openCAEdit(item) {
      this.selectedCA = item;
      this.showCADialog = true;
    },
    addToDeductions(item) {
      //format before push
      let name = item.reason ? "CA-" + item.reason : item.benefit.name;
      let amount = item.amount ? item.amount : item.benefit.amount;
      let formattedItem = {
        item_id: item.id,
        name: name,
        amount: amount,
        type: item.status ? "cash_advance" : "benefit",
      };
      this.selectedDeductions.push(formattedItem);
    },
    removeDeduction(dec, index) {
      // penalty rows live in the penalties inputs, not selectedDeductions
      if (dec.type === "penalty") {
        this.penalties[dec.penalty_key] = null;
        return;
      }
      this.selectedDeductions.splice(index, 1);
    },
    convertFormat(number) {
      let formattedNumber = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
      return formattedNumber;
    },
    async selectEmployee(employee) {
      //clear income, deduction array, total days work, etc.
      this.form.total_days_worked = null;
      this.form.overtime = 0;
      this.selectedDeductions = [];
      this.penalties = { absences: null, lates: null, undertime: null };
      this.form.gross = null;
      this.form.net = null;
      this.form.notes = "n/a";
      this.printableWage = {};

      this.showPosition = true;
      console.log("selected", employee);

      // get employee cash advances
      this.getEmployeeCashAdvances(employee);
      // get employee benefits from api
      this.getEmployeeBenefits(employee);
    },
    async getEmployeeBenefits(employee) {
      let response2 = await axios.get("/employee_benefits/" + employee.id);
      console.log("employee benefits", response2.data);
      this.employeeBenefits = response2.data;
      //calculate total benefit amount
      let totalBenefitAmount = response2.data.reduce(
        (sum, benefit) => sum + parseFloat(benefit.benefit.amount),
        0
      );

      console.log("total benefit amount", totalBenefitAmount);
    },
    async getEmployeeCashAdvances(employee) {
      // get employee cash advances from api
      let response = await axios.get("/cash_advance/" + employee.id);
      console.log("cash advances", response.data);
      this.cashAdvances = response.data;
      //calculate total cash advance amount
      let totalCAAmount = response.data.reduce(
        (sum, ca) => sum + parseFloat(ca.amount),
        0
      );
      console.log("total cash advance amount", totalCAAmount);
    },
    ...mapActions({
      add_wage: "wage/add_wage",
    }),
    async submit() {
      let x = await this.$confirm({
        title: "Submit Payslip",
        message: "Are you sure you want to proceed?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (x) {
        //assign fields to form
        this.form.employee_id = this.selectedEmployee.id;
        this.form.deductions = this.allDeductions;
        this.form.gross = this.grossPay;
        this.form.net = this.totalNet;
        this.form.pay_type = this.isFixedMode ? "fixed" : "daily";
        if (this.isFixedMode) {
          // fixed salary is not day-based; keep the column filled for the schema
          this.form.total_days_worked = 0;
          if (!(parseFloat(this.selectedEmployee.monthly_salary) > 0)) {
            this.$alert({
              title: "Validation",
              message:
                "This employee is Regular but has no monthly salary set. Set it in Edit Employee first.",
              color: "warning",
              icon: "mdi-alert",
            });
            return;
          }
        }
        //check if fields are empty
        if (
          !this.form.employee_id ||
          !this.form.month ||
          !this.form.year ||
          !this.form.half ||
          (!this.isFixedMode && !this.form.total_days_worked)
        ) {
          this.$alert({
            title: "Validation",
            message: "Please fill all required fields",
            color: "warning",
            icon: "mdi-alert",
          });
          return;
        }
        this.loading = true;

        try {
          let response = await this.add_wage(this.form);
          this.printableWage = response.data;
          console.log("wage added", response.data);
          this.loading = false;
          this.$alert({
            title: "Success",
            message: "Wage added successfully",
            color: "success",
            icon: "mdi-check-circle",
          });

          // Ask if user wants to print the payslip
          let printConfirm = await this.$confirm({
            title: "Print Payslip",
            message: "Would you like to print the payslip?",
            color: "success",
            icon: "mdi-printer",
          });
          if (printConfirm) {
            this.printSlip();
          }
        } catch (error) {
          console.error(error);
          this.loading = false;
          this.$alert({
            title: "Error",
            message: "An error occurred while adding the wage.",
            color: "error",
            icon: "mdi-alert-circle",
          });
        }
      }
    },
  },
  mounted() {
    //set form.month and form.year to current month and year using moment.js
    this.form.month = moment().format("M");
    this.form.year = moment().format("YYYY");
    if (!this.branches || this.branches.length === 0) {
      this.$store.dispatch("branch/get_branches");
    }
    this.selectedBranchId = this.user.branch_id;
  },
};
</script>
